import {greys, greysDark} from '../../styles/colorStyles';
import {
  redesignedDarkAppFrameSemanticStyles,
  redesignedLightAppFrameSemanticStyles,
} from './appFrameSemanticStyles';

export interface VerticalSwitcherSemanticStyles {
  background: string;
  itemColor: string;
  itemIconColor: string;
}

export const lightVerticalSwitcherSemanticStyles = {
  background: greys.shade20,
  itemColor: greys.shade90,
  itemIconColor: greys.shade80,
} as const satisfies VerticalSwitcherSemanticStyles;

export const darkVerticalSwitcherSemanticStyles = {
  background: greysDark.white,
  itemColor: greysDark.shade90,
  itemIconColor: greysDark.black,
} as const satisfies VerticalSwitcherSemanticStyles;

export const redesignedLightVerticalSwitcherSemanticStyles = {
  ...lightVerticalSwitcherSemanticStyles,
  background: redesignedLightAppFrameSemanticStyles.backgroundColor,
} as const satisfies VerticalSwitcherSemanticStyles;

export const redesignedDarkVerticalSwitcherSemanticStyles = {
  ...darkVerticalSwitcherSemanticStyles,
  background: redesignedDarkAppFrameSemanticStyles.backgroundColor,
} as const satisfies VerticalSwitcherSemanticStyles;
